import { render, staticRenderFns } from "./FileUploadWidget.vue?vue&type=template&id=9a8c806c&scoped=true"
import script from "./FileUploadWidget.vue?vue&type=script&lang=js"
export * from "./FileUploadWidget.vue?vue&type=script&lang=js"
import style0 from "./FileUploadWidget.vue?vue&type=style&index=0&id=9a8c806c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8c806c",
  null
  
)

export default component.exports